import Joi from "joi-browser";

/**
 * Builds the form template + Joi schema for an "assistant transfer agent"
 * (internal assistant-to-assistant transfer), distinct from human agents.
 *
 * The target assistant is chosen from a dropdown of the workspace's other
 * voice assistants, so the options are passed in dynamically.
 */
function getAssistantTransferAgentFields(
  assistantOptions: { id: number; value: string; label: string }[]
) {
  const fields = {
    name: {
      template: {
        name: "name",
        type: "text",
        label: "Name",
      },
      schema: Joi.string().required().label("Agent Name"),
    },
    assistantId: {
      template: {
        name: "assistantId",
        type: "select",
        label: "Transfer To Assistant",
        options: assistantOptions,
      },
      schema: Joi.string().required().label("Assistant"),
    },
    trigger: {
      template: {
        name: "trigger",
        type: "textArea",
        style: { height: "100px" },
        label: "Trigger",
      },
      schema: Joi.string().allow(null, ""),
    },
    dynamicWelcomeMessageEnabled: {
      template: {
        name: "dynamicWelcomeMessageEnabled",
        type: "toggle",
        label: "Dynamic Welcome Message",
        description:
          "Let the target assistant generate its opening line from the conversation so far, instead of using its configured welcome message.",
      },
      schema: Joi.boolean().label("Dynamic Welcome Message"),
    },
  };

  const template = Object.values(fields).map((field) => field.template);
  const schema = Object.keys(fields).reduce((acc, key) => {
    return { ...acc, [key]: fields[key].schema };
  }, {});

  return { template, schema };
}

export { getAssistantTransferAgentFields };
